module.exports = __webpack_public_path__ + "img/safari@2x.5e9413a9.png";